import { PulseLoader } from "react-spinners";
import "./Loader.css";

const Loader = ({
  fullScreen = false,
  overlay = false,
  size,
  color = "#f26522",
  text,
  minHeight = "200px",
  className = "",
}) => {
  const containerClasses = [
    "bb-loader-container",
    fullScreen ? "bb-loader-fullscreen" : "",
    overlay ? "bb-loader-overlay" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const containerStyle =
    !fullScreen && !overlay && minHeight ? { minHeight } : undefined;

  return (
    <div
      className={containerClasses}
      style={containerStyle}
      role="status"
      aria-label="Loading"
    >
      <div className="bb-loader-content">
        <div className="bb-loader-spinner">
          <PulseLoader
            color={color}
            size={size || 12}
            margin={4}
            speedMultiplier={0.85}
          />
        </div>
        {text && <p className="bb-loader-text">{text}</p>}
      </div>
    </div>
  );
};

export default Loader;
